function Menu() {
	var self = this;
	this.init();
}

Menu.prototype.init = function() {
	var self = this;
	this.toggleMenu();
	this.toggleMobileMenu();
	this.handleMobileSubmenu();
};

Menu.prototype.toggleMenu = function() {
	var self = this;
	$('.header-menu-container > ul > li').hoverIntent(
		function(e) {
			$(e.currentTarget).siblings().find('ul').removeClass('-visible');
			if ($(e.currentTarget).find('ul').length) {
				$('.header').addClass('-background');
				$(e.currentTarget).find('ul').addClass('-visible');
			} else {
				$('.header').removeClass('-background');
			}
		},
		function(e) {}
	);
	$('.header').hoverIntent(
		function(e) {},
		function(e) {
			$('.header').removeClass('-background');
			$('.header-menu').find('ul').removeClass('-visible');
		}
	);
};

Menu.prototype.toggleMobileMenu = function() {
	var self = this;
	$('.header-menu').on('click', function(e) {
		e.stopPropagation();
	});
	$('.menu-button').on('click', function(e) {
		e.stopPropagation();
		if ($('body').hasClass('-menu-open')) {
			app.handleBannerSubtitlePosition();
		}
		$('.header').toggleClass('-active');
		$('body').toggleClass('-menu-open');
		if ($('.header').hasClass('-active')) {
			$('.header-menu-list').removeClass('-expanded');
			$('html, body').animate({scrollTop: 0}, 0);
		}
	});
	$(document).on('click', function() {
		$('.header').removeClass('-active');
		$('.header-menu-list').removeClass('-expanded');
	});
};

Menu.prototype.handleMobileSubmenu = function() {
	var self = this;
	$('.header-menu-list-item__link').on('click', function(e) {
		if ($(this).attr('href') == '#' && $(this).siblings('.header-menu-list').length) {
			e.preventDefault();
			$(this).siblings('.header-menu-list').toggleClass('-expanded');
		}
	});
};